import { useEffect, createElement } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useBexApi } from '@shared-ui/bex-api-context';

/* tslint:disable */
/* eslint-disable */
/* istanbul ignore next */
// @ts-nocheck
var initQualtrics = function (zoneId) {
    var g = function (e, h, f, g) {
        this.get = function (a) {
            for (var a = a + "=", c = document.cookie.split(';'), b = 0, e = c.length; b < e; b++) {
                for (var d = c[b]; d.charAt(0) == ' ';)
                    d = d.substring(1, d.length);
                if (d.indexOf(a) == 0)
                    return d.substring(a.length, d.length);
            }
            return null;
        };
        this.set = function (a, c) {
            var b = '';
            var b = new Date();
            b.setTime(b.getTime() + 6048e5);
            b = "; expires=" + b.toGMTString();
            document.cookie = a + "=" + c + b + "; path=/; ";
        };
        this.check = function () {
            var a = this.get(f);
            if (a)
                a = a.split(':');
            else if (e != 100)
                h == 'v' && (e = Math.random() >= e / 100 ? 0 : 100), (a = [h, e, 0]), this.set(f, a.join(':'));
            else
                return !0;
            var c = a[1];
            if (c == 100)
                return !0;
            switch (a[0]) {
                case 'v':
                    return !1;
                case 'r':
                    return (c = a[2] % Math.floor(100 / c)), a[2]++, this.set(f, a.join(':')), !c;
            }
            return !0;
        };
        this.go = function () {
            if (this.check()) {
                var a = document.createElement('script');
                a.type = 'text/javascript';
                a.src = g;
                document.body && document.body.appendChild(a);
            }
        };
        this.start = function () {
            var t = this;
            document.readyState !== 'complete'
                ? window.addEventListener
                    ? window.addEventListener('load', function () {
                        t.go();
                    }, !1)
                    : window.attachEvent &&
                        window.attachEvent('onload', function () {
                            t.go();
                        })
                : t.go();
        };
    };
    try {
        new g(100, 'r', "QSI_S_" + zoneId, "https://" + zoneId.toLowerCase().replace(/_/g, '') + "-expediainc.siteintercept.qualtrics.com/SIE/?Q_ZID=" + zoneId).start();
    }
    catch (i) { }
};

/**
 * @protected
 * Exposing for package internal usage and unit tests only.
 * Do not export queries at the top level of the package.
 */
var __Query = { "kind": "Document", "definitions": [{ "kind": "OperationDefinition", "operation": "query", "name": { "kind": "Name", "value": "QualtricsConfigQuery" }, "variableDefinitions": [{ "kind": "VariableDefinition", "variable": { "kind": "Variable", "name": { "kind": "Name", "value": "context" } }, "type": { "kind": "NonNullType", "type": { "kind": "NamedType", "name": { "kind": "Name", "value": "ContextInput" } } }, "defaultValue": undefined, "directives": [] }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "qualtricsConfig" }, "arguments": [{ "kind": "Argument", "name": { "kind": "Name", "value": "context" }, "value": { "kind": "Variable", "name": { "kind": "Name", "value": "context" } } }], "directives": [], "selectionSet": { "kind": "SelectionSet", "selections": [{ "kind": "Field", "alias": undefined, "name": { "kind": "Name", "value": "zoneId" }, "arguments": [], "directives": [], "selectionSet": undefined }] } }] } }], "loc": { "start": 0, "end": 121, "source": { "body": "\n  query QualtricsConfigQuery($context: ContextInput!) {\n    qualtricsConfig(context: $context) {\n      zoneId\n    }\n  }\n", "name": "GraphQL request", "locationOffset": { "line": 1, "column": 1 } } } };
/**
 * Component to return qualtrics script tag.
 */
var Qualtrics = function (props) {
    var _a;
    var context = useBexApi().context;
    var skipSsr = props.skipSsr;
    var variables = {
        context: context
    };
    var _b = useQuery(__Query, { variables: variables, ssr: !skipSsr }), data = _b.data, error = _b.error, loading = _b.loading;
    var zoneId = (_a = data === null || data === void 0 ? void 0 : data.qualtricsConfig) === null || _a === void 0 ? void 0 : _a.zoneId;
    useEffect(function () {
        initQualtrics(zoneId);
    }, [zoneId]);
    if (loading || error || !zoneId) {
        return null;
    }
    return createElement("div", { "data-stid": zoneId, id: zoneId });
};
Qualtrics.displayName = 'Qualtrics';

export { Qualtrics };
